import { render, staticRenderFns } from "./OnboardingView.vue?vue&type=template&id=5a7d735c&scoped=true&"
import script from "./OnboardingView.vue?vue&type=script&lang=js&"
export * from "./OnboardingView.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingView.vue?vue&type=style&index=0&id=5a7d735c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7d735c",
  null
  
)

export default component.exports